import React, { useEffect, useState } from 'react';
import './Profile.css';
import { MdOutlineEmail } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import user from './avathar-images.png';
import { FaPhoneAlt } from 'react-icons/fa';
import { CgProfile } from "react-icons/cg";


const Profile = () => {
  const [userInfo, setUserInfo] = useState({ name: '', email: '', location: '' });
  const navigate = useNavigate();

   useEffect(() => {
      const fetchUserDetails = async () => {
        try {
          const response = await fetch(
            "https://riymay.com/api/v1/user/getuserdetails",
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          if (response.ok) {
            const data = await response.json();
            setUserInfo(data.user);// Save userId for updates
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };
  
      fetchUserDetails();
    }, []);

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    navigate('/login');
  };

  return (
    <div>
      <div className="user-profile-card">
        <div className="user-cover-photo">
          {/* <img src={user} className="user-profile-img" alt="User Avatar" /> */}
        </div>
        {/* <div className="user-profile-name">{userInfo.firstName}</div> */}
        <div className="user-about">

        {localStorage.getItem("userToken") ? (




<div>
<div className="user-profile-name">{userInfo.firstName}</div>

          {/* <p className="profile-card-icons">
            <CgProfile             size={20} style={{ padding: '8px' }} /> : {userInfo.firstName}
          </p> */}
          <p className="profile-card-icons">
            <MdOutlineEmail size={20} style={{ padding: '8px' }} /> : {userInfo.email}
          </p>
          {/* <p className="profile-card-icons">
            <FaPhoneAlt size={12} style={{ padding: '8px' }} /> : {userInfo.phone}
          </p> */}
         </div> 

) : ""}
        </div>
        {localStorage.getItem("userToken") ? (

        <Link to="/newuserprofile">
          <button className="user-msg-btn">Edit Profile</button>
        </Link>):""}
        <button className="user-follow-btn" onClick={handleLogout}>
  {localStorage.getItem("userToken") ? "Logout" : "Login"}
</button>

      </div>
    </div>
  );
};

export default Profile;
